import React, { useState } from 'react'
import {
  Tr,
  Th,
  Animation,
  PageWrapper,
  H1WithBack,
  PageFooter,
  Table,
  Flex,
  Button,
  ColoredDot,
} from 'styling/GlobalStyles'
import { Td } from 'components/Td/Td'
import {
  convertAbsence,
  convertMinsToHrsMins,
  getParams,
  handlePagination,
} from 'utils/helpers'
import { NavBar } from 'components/NavBar/NavBar'
import { useDispatch, useSelector } from 'react-redux'
import { clearShiftsList, deleteShift, getShifts } from 'features/shifts/shiftsSlice'
import { setConfirmModal } from 'features/global/globalSlice'
import { AppDispatch, RootState } from 'store'
import { ISingleShift } from 'types/shifts.interface'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import useQueryPagination from 'hooks/useQueryPagination'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { Options } from 'components/Options/Options'
import { IShiftModal, ShiftsModal } from './ShiftsModal'
import { absenceList } from './shiftsData'
import { IGetAllShiftsSingleResponse } from 'types/api/shiftsApi.interface'
import { FoodTableContainer } from 'pages/Food/Food.styled'
import { useNavigate } from 'react-router-dom'
import { clearAiRules, getWorkSchedulesAiRule } from 'features/work-schedules/workScheduleSlice'
import { AiRulesModal } from './AIRulesModal'
import { ModalTypes } from 'types/global.interface'

export const Shifts = () => {
  const { shifts, totalPages } = useSelector((store: RootState) => store.shifts)
  const dispatch = useDispatch<AppDispatch>()
  const [modal, setModal] = useState({ value: null, open: false })
  const [ruleModal, setRuleModal] = useState({ open: false, value: null })
  const { aiRule } = useSelector((store: RootState) => store.workSchedules)
  const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
  const navigate = useNavigate()


  useQueryPagination({ fetchFunctions: [getShifts, getWorkSchedulesAiRule], cleanUpFunctions: [clearShiftsList, clearAiRules], params })

  const removeShift = (id: number): void => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: () => {
          dispatch(deleteShift(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: shifts.length < 2,
        },
        word: 'delete shift',
      }),
    )
  }

  const getModalValue = (item: ISingleShift): IShiftModal => {
    return {
      id: item.id,
      name: item.name,
      absenceType: absenceList.find(a => a.value == (item.absenceType ?? 6)),
      info: item.info,
      color: item.color ? ('#' + item.color) : '#ff9900',
      range: {
        shiftStart: item.shiftStart,
        minutes: item.minutes,
        minutesSelected: true,
        startSelected: true
      }
    }
  }

  return (
    <>
      <NavBar />
      <PageWrapper >
        <Animation>
          <Flex between center >
            <H1WithBack arrow title='Shifts' link='/hr/schedule' />
            <Flex gap='1rem' >
              <Button orange onClick={() => navigate('/hr/schedule/work-schedule-models')}>
                Manage Models
              </Button>
              <Button orange onClick={() => navigate('add')}>Add Shift</Button>

            </Flex>
          </Flex>
          <Flex mt='16' gap='1rem' height='100%' >
            <FoodTableContainer style={{ width: '40%', height: '100%', flex: 1 }} >
              <Flex width='100%' between center>
                <TitleText weight='bold' >SHIFT RULES</TitleText>
                <Button orange onClick={() => setRuleModal({ value: aiRule?.rule, open: true })}>{aiRule?.rule ? 'Edit' : 'Add'} Rules</Button>
              </Flex>
              <Flex width='100%' mt='16' column >
                {aiRule ? aiRule.rule?.split('\n').map(r => <BodyText key={r} >{r}</BodyText>) : <TitleText>No Rule Set Yet</TitleText>}
              </Flex>
            </FoodTableContainer>
            <FoodTableContainer style={{ width: '60%' }} >
              {!shifts.length ? (
                <NoItems title='Shifts' />
              ) : (
                <Table width='100%' >
                  <Th minWidth={0} next >
                    <Td w='5%' noTooltip></Td>
                    <Td w='20%' noTooltip text='Shift Title' />
                    <Td w='15%' noTooltip text='From' />
                    <Td w='15%' noTooltip text='To' />
                    <Td w='15%' noTooltip text='Description' />
                    <Td w='5%' options></Td>
                  </Th>
                  {shifts.map((item: IGetAllShiftsSingleResponse) => {
                    return (
                      <Tr small minWidth={0} key={item.id}>
                        <Td w='5%'><ColoredDot color={item.color ? ('#' + item.color) : '#ff9900'} /></Td>
                        <Td w='20%' text={item.name} />
                        <Td w='15%' noTooltip>
                          <OtherText style={item.absenceType ? { color: '#FF4F46' } : {}}>
                            {item.absenceType
                              ? convertAbsence(item.absenceType)
                              : convertMinsToHrsMins(item.shiftStart)}
                          </OtherText>
                        </Td>
                        <Td w='15%' noTooltip>
                          <OtherText style={item.absenceType ? { color: '#FF4F46' } : {}}>
                            {item.absenceType
                              ? convertAbsence(item.absenceType)
                              : convertMinsToHrsMins(item.minutes, item.shiftStart, true)}
                          </OtherText>
                        </Td>
                        <Td cutText toolTipText={item.info} w='40%'>
                          <OtherText>{item.info}</OtherText>
                        </Td>
                        <Td options noTooltip w='5%'>
                          <Options handleRemove={removeShift} openModal={() => navigate('edit/' + item.id.toString())} title='Shift' item={item} />
                        </Td>
                      </Tr>
                    )
                  })}
                </Table>
              )}
            </FoodTableContainer>

          </Flex>


        </Animation>
      </PageWrapper>
      <PageFooter>
        {totalPages > 1 && (
          <Pagination
            setPage={(page) => handlePagination(page, setParams, 30)}
            pageCount={Math.ceil(totalPages)}
            forcePage={(params.page ? params.page : 1) - 1}
          />
        )}
      </PageFooter>
      {ruleModal.open && <AiRulesModal value={ruleModal.value} closeModal={() => setRuleModal({ value: null, open: false })} />}
      {modal.open && <ShiftsModal value={modal.value} closeModal={() => setModal({ open: false, value: modal.value })} />}
    </>
  )
}
